<template>
  <div class="account-page" :class="{ active: active }" :data-account-page="id">
    <div class="tabbed">
      <div class="tab-header">
        <internal-nav
          class="tabs"
          :active-item="activeSubpage"
          :items="navItems"
          @select="changePage"
        ></internal-nav>
        <!-- <span
          class="tags"
          v-if="!$store.getters['user/stripeConnectIsOnboarded']"
        >
          <span class="alert-tag error"
            >Please complete your payment details</span
          >
        </span> -->
      </div>
      <div class="content-panes" v-if="active || wasActive">
        <account-profile
          :class="{ active: activeSubpage === 'index' }"
        ></account-profile>
        <account-payment-details
          :class="{ active: activeSubpage === 'payment' }"
          ref="paymentDetails"
        ></account-payment-details>
      </div>
    </div>
  </div>
</template>

<script>
import AccountSubpage from "../../../AccountSubpage";
import AccountPaymentDetails from "./subpages/PaymentDetails";
import AccountProfile from "../../../shared/panels/main/subpages/Profile";

export default {
  extends: AccountSubpage,
  components: {
    AccountPaymentDetails,
    AccountProfile,
  },
  mounted() {
    this.$eventBus.$on("accountNavigate", (mutation) => {
      if (
        (mutation.payload.page === "account-details" &&
          mutation.payload.subpage === "payment") ||
        (mutation.type === "account/navigateSubpage" &&
          mutation.payload === "payment")
      ) {
        this.$nextTick(() => {
          if (this.$store.getters["account/from"].subpage === "payment") {
            return;
          }
          this.$refs.paymentDetails.getConnectAccount();
        });
      }
    });
  },
  data() {
    return {
      id: "account-details",
    };
  },
  computed: {
    navItems() {
      return [
        { id: "index", label: "Profile" },
        { id: "payment", label: "Payment Details" },
      ];
    },
  },
};
</script>
